import { Typography } from "@material-tailwind/react";

import React, { useEffect, useState } from "react";
import KSData from "../../KS.json";
import ManualTime from "../ManualTime";

const LastThirdTime = () => {
  const [result, setResult] = useState("");
  const [countdown, setCountdown] = useState("");

  useEffect(() => {
    const jsonData = KSData;

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // Months are zero-based
    const currentDay = currentDate.getDate();

    const maghribTime = jsonData.find(
      (data) => data.Month === currentMonth && data.Date === currentDay
    );

    const nextDate = new Date(currentDate);
    nextDate.setDate(currentDate.getDate() + 1);
    const nextDayMonth = nextDate.getMonth() + 1; // Months are zero-based
    const nextDay = nextDate.getDate();

    const fajrTime = jsonData.find(
      (data) => data.Month === nextDayMonth && data.Date === nextDay
    );

    const [maghribHours, maghribMinutes] = maghribTime.Akshami.split(":");
    const [fajrHours, fajrMinutes] = fajrTime.Imsaku.split(":");

    const sabahu = parseInt(fajrMinutes, 10) + 30;

    currentDate.setHours(maghribHours, maghribMinutes, 0); // Set seconds to 0
    nextDate.setHours(fajrHours, sabahu, 0); // Set seconds to 0

    const totalTime = nextDate.getTime() - currentDate.getTime();
    const lastThirdTime = totalTime / 3;

    const startingTimeOfLastThird = new Date(
      currentDate.getTime() + (totalTime - lastThirdTime)
    );

    let hours = startingTimeOfLastThird.getHours();
    if (hours > 23) {
      hours -= 24;
    }
    const timeString = `${hours
      .toString()
      .padStart(2, "0")}:${startingTimeOfLastThird
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;
    setResult(timeString);

    // Calculate countdown
    const formatTime = (time) => {
      const hours = Math.floor(time / (1000 * 60 * 60))
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60))
        .toString()
        .padStart(2, "0");
      const seconds = Math.floor((time % (1000 * 60)) / 1000)
        .toString()
        .padStart(2, "0");
      // Adjust hours if it exceeds 24
      const adjustedHours =
        hours >= 24
          ? (parseInt(hours, 10) - 24).toString().padStart(2, "0")
          : hours;

      return `${adjustedHours}:${minutes}:${seconds}`;
    };

    const updateCountdown = () => {
      const currentTime = new Date().getTime();
      const startingTime = startingTimeOfLastThird.getTime();
      const timeLeft = startingTime - currentTime;
      setCountdown(formatTime(timeLeft));
    };

    // Update countdown initially
    updateCountdown();

    // Start countdown interval
    const countdownInterval = setInterval(updateCountdown, 1000);

    // Clear interval on component unmount
    return () => {
      clearInterval(countdownInterval);
    };
  }, []);

  return (
    <>
      <figure className="relative  gap-4 flex flex-col items-center justify-center  w-full h-full bg-blue-gray-800 pb-10 pt-10">
        <figcaption className="h-min w-[calc(100%-2rem)] max-w-[350px] mx-auto px-3 sm:px-4 text-center">
          <Typography variant="h3" color="white">
            Pjesa e tretë e natës
          </Typography>
          <Typography variant="small" color="white">
            Llogaritja sipas takvimit të Kosovës
          </Typography>
        </figcaption>

        <figcaption className=" z-20 relative w-[calc(100%-2rem)] max-w-[350px] mx-auto px-3 sm:px-4 rounded-xl border border-white bg-white/75 py-6">
          <div className="flex flex-col items-center">
            <Typography variant="h5" color="blue-gray" className="mb-4 text-center px-2">
              Pjesa e tretë fillon në ora:
            </Typography>
            <div className="w-full flex justify-center">
              <Typography variant="h2" color="blue-gray">
                {result}
              </Typography>
            </div>
          </div>
        </figcaption>

        <figcaption className="relative w-[calc(100%-2rem)] max-w-[350px] mx-auto px-3 sm:px-4 rounded-xl border border-white bg-white/75 py-6">
          <div className="flex flex-col items-center">
            <Typography variant="h5" color="blue-gray" className="mb-4 text-center px-2">
              Deri në pjesën e tretë:
            </Typography>
            <div className="w-full flex justify-center">
              <Typography variant="h2" color="blue-gray">
                {countdown}
              </Typography>
            </div>
          </div>
        </figcaption>
      </figure>

      <div className="relative -mt-2">
        <ManualTime showMidnight={false} />
      </div>
    </>
  );
};

export default LastThirdTime;
